import ContractPage from './ContractsPage';
import { Container } from '@mui/material';
import Cookies from 'universal-cookie'

const MisContratoPage = () => {
  const cookies = new Cookies();

  return (
      <ContractPage myAccount={cookies}/>
  );
};

export default MisContratoPage;